import { render, staticRenderFns } from "./Item1.vue?vue&type=template&id=cbde524e&scoped=true"
import script from "./Item1.vue?vue&type=script&lang=js"
export * from "./Item1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbde524e",
  null
  
)

export default component.exports